import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import ErrorText from "@/components/universal/error-text";
import { getGetCatalogProductQueryOptions } from "@/requests/gen/react-query/catalog-product";
import CatalogProductCard from "@/components/product-cards/catalog-product-card";
import { CatalogCrumbs } from "../-crumbs";
import CatalogProductTabs from "./-tabs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/catalog-product/$catalogProductId/",
)({
  loader: ({ context: { queryClient }, params: { catalogProductId } }) =>
    queryClient.ensureQueryData(
      getGetCatalogProductQueryOptions(numericId(catalogProductId)),
    ),
  component: CatalogProductDetailsPage,
});

function CatalogProductDetailsPage() {
  const { catalogProductId } = Route.useParams();
  const catalogProductIdInt = numericId(catalogProductId);

  const {
    data: product,
    error,
    refetch,
  } = useSuspenseQuery(
    suspenseOptions(getGetCatalogProductQueryOptions(catalogProductIdInt)),
  );

  return (
    <div>
      <title>{`${product?.product_base.name} Catalog Details - Legrande Health Portal`}</title>
      <CatalogCrumbs />
      {error && <ErrorText text="Failed to load product details" />}
      {product && (
        <div className="grid gap-6 xl:grid-cols-2 *:min-w-0">
          <div>
            <CatalogProductCard catalog_product={product} refetch={refetch} />
          </div>
          <CatalogProductTabs
            catalogProductId={catalogProductIdInt}
            product={product}
          />
        </div>
      )}
    </div>
  );
}
